import { Link } from "react-router-dom";

const faqs = [
  {
    q: "178漫画网是什么？",
    a: "178漫画网是漫友同好交流聚集地，按作品和题材划分漫圈。在这里你可以找到追同部漫画的同好，一起讨论剧情、分享心得，还可以参与热门作品专属圈子里的讨论。",
  },
  {
    q: "如何加入一个漫圈？",
    a: "进入「漫圈社区」页面，找到你感兴趣的作品或题材圈子，点击「进圈看看」即可加入。加入后就能在圈子里发帖、回帖、参与讨论。",
  },
  {
    q: "每部漫画下面都有讨论区吗？",
    a: "是的。178漫画网的每一部作品都配有专属讨论区，方便同好针对具体剧情展开交流。热门作品还会额外开设更为细分的圈子，方便深入讨论。",
  },
  {
    q: "我可以在漫圈里发帖吗？",
    a: "当然可以。注册后即可在任意漫圈发布话题，无论是剧情解读、求安利还是个人心得都很欢迎，只要遵守社区规范、友善交流即可。",
  },
  {
    q: "使用178漫画网需要付费吗？",
    a: "基础的漫圈交流、发帖回帖、浏览讨论区均免费。部分增值功能（如进阶会员、专属徽章等）可能会单独说明，但常规的同好交流不收费。",
  },
];

export default function FaqSection() {
  return (
    <section className="py-14 md:py-20 bg-background-100">
      <div className="mx-auto max-w-7xl px-4 md:px-6">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-10 md:gap-14">
          <div>
            <span className="text-xs font-medium tracking-widest text-accent-600">常见问题</span>
            <h2 className="mt-2 font-heading text-2xl md:text-4xl text-foreground-950">
              关于178漫画网的疑问
            </h2>
            <p className="mt-3 text-sm md:text-base text-foreground-600">
              第一次来漫圈？这里集中回答了最常被问到的问题，帮你快速上手，找到同好开聊。
            </p>
            <Link
              to="/about"
              className="mt-6 inline-flex items-center gap-1.5 whitespace-nowrap text-sm font-medium text-primary-600 hover:text-primary-500"
            >
              了解更多关于我们 <i className="ri-arrow-right-line" />
            </Link>
          </div>

          <div className="flex flex-col gap-3">
            {faqs.map((f) => (
              <details
                key={f.q}
                className="group rounded-2xl border border-background-200 bg-background-50 px-5 py-4 open:border-primary-300"
              >
                <summary className="flex cursor-pointer list-none items-center justify-between gap-3 font-heading text-base text-foreground-950">
                  {f.q}
                  <i className="ri-add-line text-lg text-primary-600 transition-transform group-open:rotate-45" />
                </summary>
                <p className="mt-3 text-sm leading-6 text-foreground-600">{f.a}</p>
              </details>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}